import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Layout from "./util/Layout";
import Login from "./Login";
import BookTable from "./books/BookTable";
import RecipeTable from "./recipes/RecipeTable";
import Recipe from "./recipes/Recipe";
import Dashboard from "./Dashboard";
import Footer from "./util/Footer";
import Book from "./books/Book";
import BookSearch from "./books/BookSearch";
import NewBook from "./books/NewBook";
import EditBook from "./books/EditBook";
import GroceryList from "./recipes/GroceryList";
import TVShowLists from "./tvshows/TVShowLists";
import TVShowList from "./tvshows/TVShowList";
import AddTVShowToList from "./tvshows/AddTVShowToList";
import TVShowListItem from "./tvshows/TVShowListItem";
import TVShowListByActor from "./tvshows/TVShowListByActor";
import RestaurantLists from "./restaurants/RestaurantLists";
import CreateRestaurantList from "./restaurants/CreateRestaurantList";
import RestaurantList from "./restaurants/RestaurantList";
import AddRestaurantToList from "./restaurants/AddRestaurantToList";
import RestaurantListItem from "./restaurants/RestaurantListItem";

const App = () => {
  return (
    <Router>
      <div className="App">
        <Layout>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/books" element={<BookTable />} />
            <Route path="/books/search" element={<BookSearch />} />
            <Route path="/books/new" element={<NewBook />} />
            <Route path="/books/:sid" element={<Book />} />
            <Route path="/books/:sid/edit" element={<EditBook />} />
            <Route path="/recipes" element={<RecipeTable />} />
            <Route path="/recipes/:sid" element={<Recipe />} />
            <Route path="/grocerylist" element={<GroceryList />} />
            <Route path="/tvshows" element={<TVShowLists />} />
            <Route path="/tvshows/:sid" element={<TVShowList />} />
            <Route
              path="/tvshows2/:listsid/:actorSid"
              element={<TVShowListByActor />}
            />
            <Route path="/tvshows/:listsid/:sid" element={<TVShowListItem />} />
            <Route path="/tvshows/:sid/add" element={<AddTVShowToList />} />
            <Route path="/restaurants" element={<RestaurantLists />} />
            <Route path="/restaurants/new" element={<CreateRestaurantList />} />
            <Route path="/restaurants/:sid" element={<RestaurantList />} />
            <Route
              path="/restaurants/:sid/add"
              element={<AddRestaurantToList />}
            />
            <Route
              path="/restaurants/:listsid/:sid"
              element={<RestaurantListItem />}
            />
          </Routes>
          <Footer></Footer>
        </Layout>
      </div>
    </Router>
  );
};

export default App;
